import React, { useMemo } from 'react'
import { Form } from 'react-bootstrap'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { randomId } from '../../utils/utils'
import './Toggle.module.scss'

const propTypes = {
  /**
   * Label text for toggle button
   */
  labelText: PropTypes.string,
  /**
   * Callback for when the toggle gets changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * set initial state of Toggle
   */
  checked: PropTypes.bool,
  /**
   * set Toggle disabled
   */
  disabled: PropTypes.bool,
  /**
   * Id of the switch
   */
  id: PropTypes.string,

  /**
   * Label style for toggle button
   */
  labelTextStyle: PropTypes.string,
  /**
   * Optional class on the form-check wrapper
   */
  className: PropTypes.string,
  /**
   * Accessible label for the switch control (visually optional when `labelText` is empty)
   */
  ariaLabel: PropTypes.string,
  /**
   * Native tooltip (e.g. for disabled/overlay context)
   */
  title: PropTypes.string,
}

/**
 * Toggle — Bootstrap 5 `form-check` + `form-switch` (https://getbootstrap.com/docs/5.3/forms/checks-radios/#switches)
 * Styling: colocated `form-switch.bootstrap5.scss` (Toggle import + host `style.react.scss`) + `--aug-form-switch-*` in host theme.
 */
function Toggle(props) {
  const {
    labelText = '',
    onChange,
    checked = false,
    disabled = false,
    id = null,
    labelTextStyle = '',
    className = '',
    ariaLabel,
    title: titleAttr,
  } = props ?? {}

  const fallbackId = useMemo(() => randomId(), [])
  const switchId = id ?? `${fallbackId}-switch`

  const formCheck = (
    <Form.Check
      type="switch"
      id={switchId}
      reverse
      role="switch"
      className={clsx('Uic-Toggle', className)}
      disabled={disabled}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      aria-label={ariaLabel}
      label={<span className={clsx(labelTextStyle, 'Uic-Toggle-switch_label')}>{labelText}</span>}
    />
  )

  if (titleAttr) {
    return (
      <span title={titleAttr} className="d-inline-flex align-items-center">
        {formCheck}
      </span>
    )
  }

  return formCheck
}

Toggle.propTypes = propTypes

export default Toggle
